import React from 'react';
import styled from 'styled-components';

import Stack from 'components/Stack';
import Text from 'components/Text';
import TalkToUsCTA from 'components/TalkToUsCTA';

import { color } from 'styles/utils';

const StyledContainer = styled.div`
  background-color: ${color('white')};
  border-radius: 0.5rem;
  padding: 1.5rem;
`;

const StyledTitle = styled(Text)`
  font-weight: bold;
`;

export default function GetDemo() {
  return (
    <StyledContainer>
      <Stack gap="1rem">
        <StyledTitle variant="smallestP" color="darkTeal">
          GET A SLEUTH DEMO
        </StyledTitle>
        <Text variant="smallestP" color="mediumTeal">
          Ready to engineer your efficiency?
        </Text>
        <TalkToUsCTA label="Get a Sleuth Demo" icon="arrow-up-right" />
      </Stack>
    </StyledContainer>
  );
}
